var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.033 13.324l1.27-3.44.437-.435 2.485-2.483 4.564-4.56a1.984 1.984 0 012.808.003 1.992 1.992 0 01-.003 2.815L9.03 9.784l-2.485 2.484-.436.435-3.434 1.264a.5.5 0 01-.642-.643z",
    id: "pencil-16_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pencil-16_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pencil-16_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fillRule: "nonzero",
    xlinkHref: "#pencil-16_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#pencil-16_svg__b)",
    d: "M.5 8.5l7 7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2c4-2.333 6.667-2.833 8-1.5 1.333 1.333.667 3.833-2 7.5L8 2z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fillOpacity: 0.15,
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#pencil-16_svg__b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil16);
export default __webpack_public_path__ + "static/media/pencil-16.226a81e9.svg";
export { ForwardRef as ReactComponent };